export default __webpack_public_path__ + "static/media/mashable_blog.7d101232.jpg";